import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { DataSource, Raw, Repository } from "typeorm";
import { LocationsEntity } from "./locations.entity";
import { CommonResponseModel, driverIdReq, LocationDto, PlantIdReq } from "@project-management-system/shared-models";
import { LocationsDto } from "./dto/locations-dto";
import { LocationsAdapter } from "./locations.adapter";
import { ErrorResponse } from "packages/libs/backend-utils/src/models/global-res-object";


@Injectable()
export class LocationsService {
    constructor(
        @InjectRepository(LocationsEntity)

        private repo: Repository<LocationsEntity>,
        private readonly dataSource: DataSource,
        private adapter: LocationsAdapter,

    ) { }

    async getAllActiveLocations(): Promise<CommonResponseModel> {
        const data = await this.repo.find({ where: { isActive: true },order:{"locationName":"ASC"} });
        if (data) {
          return new CommonResponseModel(true, 1, "Data Retrived", data);
        } else {
          return new CommonResponseModel(false, 0, "Data Retrived");
        }
      }


      async getActiveAllLocationByPlant(req:PlantIdReq): Promise<CommonResponseModel> {
        const data = await this.repo.find({ where: { isActive: true, plantId:req.plantId },order:{"locationName":"ASC"} });
        if (data) {
          return new CommonResponseModel(true, 1, "Data Retrived", data);
        } else {
          return new CommonResponseModel(false, 0, "Data Retrived");
        }
      }

      


      async getAllLocations(req?: driverIdReq): Promise<CommonResponseModel> {
        try {
            const query = this.repo.createQueryBuilder("location").select();
    
            if (req && req.plant) {
                query.andWhere("plantsInfo.plant_name = :plantName", { plantName: req.plant });
            }
    
            query
                .leftJoinAndSelect("location.plantsInfo", "plantsInfo")
                .orderBy("location.createdAt", "DESC");
    
            const data = await query.getMany();
    
            if (data.length > 0) {
                return new CommonResponseModel(true, 1, "Data retrieved successfully", data);
            } else {
                return new CommonResponseModel(false, 0, "No data found");
            }
        } catch (err) {
            return new CommonResponseModel(false, 0, "Error retrieving data", err.message);
        }
    }
    
      async getLocationWithoutRelation(location: string): Promise<LocationsEntity> {
        const locationResponse = await this.repo.findOne({
          where: { locationName: Raw(alias => `location_name = '${location}'`) },
        });
        if (locationResponse) {
          return locationResponse;
        }
        else {
          return null;
        }
      }
    
      async createLocation(loc: LocationsDto, isUpdate: boolean): Promise<CommonResponseModel> {
        try {
          console.log(isUpdate)
          let previousValue
          const locationsDtos: LocationsDto[] = [];
    
          if (!isUpdate) {
    
            const levelEntity = await this.getLocationWithoutRelation(loc.locationName);
            if (levelEntity) {
              // console.log(fabricsEntity,'------')
              throw new CommonResponseModel(false, 11104, 'Level already exists');
            }
          }
          else {
            const locationPrevious = await this.repo.findOne({ where: { id: loc.id } })
            previousValue = (locationPrevious.locationName)
            const locEntity = await this.getLocationWithoutRelation(loc.locationName);
            // console.log('ertyudfghjk============',certificatePrevious)
            if (locEntity) {
              if (locEntity.id != loc.id) {
                throw new CommonResponseModel(false, 11104, 'Location already exists');
              }
            }
          }
          const convertedlocationsEntity: LocationsEntity = this.adapter.convertDtoToEntity(loc, isUpdate);
    
          // console.log(convertedlocationsEntity);
          const savedlocationEntity: LocationsEntity = await this.repo.save(convertedlocationsEntity);
          const savedlocationDto:LocationsDto = this.adapter.convertEntityToDto(savedlocationEntity);
          locationsDtos.push(savedlocationDto)
          if (savedlocationDto) {
            const presentValue = loc.locationName;
            const response = new CommonResponseModel(true, 1, isUpdate ? 'Location Updated Successfully' : 'Location Created Successfully')
            const name = isUpdate ? 'updated' : 'created'
            const displayValue = isUpdate ? 'Location Updated Successfully' : 'Location Created Successfully'
            const userName = isUpdate ? savedlocationDto.updatedUser : savedlocationDto.createdUser;
            return response;
          } else {
            throw new CommonResponseModel(false, 11106, 'Location saved but issue while transforming into DTO');
          }
        } catch (error) {
          return error;
        }
      }

      async activateOrDeactivateLocation(req: LocationDto): Promise<CommonResponseModel> {
        try {
            // console.log(req.isActive, 'service-----------')
            const Exists = await this.repo.findOne({ where: { id: req.id } });
            if (Exists) {
                if (!Exists) {
                    throw new ErrorResponse(10113, 'Someone updated the current Location information.Refresh and try again');
                } else {

                    const update = await this.repo.update(
                        { id: req.id },
                        { isActive: req.isActive, updatedUser: req.updatedUser });
                    if (Exists.isActive) {
                        if (update.affected) {
                            const Response: CommonResponseModel = new CommonResponseModel(true, 10115, 'Location is Deactivated successfully');
                            return Response;
                        } else {
                            throw new CommonResponseModel(false, 10111, 'Location is already deactivated');
                        }
                    } else {
                        if (update.affected) {
                            const Response: CommonResponseModel = new CommonResponseModel(true, 10114, 'Location is activated successfully');
                            return Response;
                        } else {
                            throw new CommonResponseModel(false, 10112, 'Location is already  activated');
                        }
                    }

                }
            } else {
                throw new CommonResponseModel(false, 99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }
    
}

